var ThemeNames;
(function (ThemeNames) {
  ThemeNames["default"] = "default";
  ThemeNames["lincoln"] = "secureSite";
  ThemeNames["publicSite"] = "publicSite";
  ThemeNames["secureSite"] = "secureSite";
})(ThemeNames || (ThemeNames = {}));

export { ThemeNames };
